export default __webpack_public_path__ + "static/media/english-to-italian-screenshot-04.31027201.png";